import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import { api } from "../../lib/api";
import { useStore } from "../../context/StoreContext";
import { fmtDate, fmtTRY } from "../../lib/format";

export default function OrderSuccessPage() {
  const { orderNumber } = useParams();
  const { customer } = useStore();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const email = customer?.email || "";
    api.get(`/orders/${orderNumber}`, { params: email ? {} : {}, headers: {} })
      .then(({ data }) => setOrder(data))
      .catch(() => {
        const params = new URLSearchParams(window.location.search);
        const guest = params.get("email");
        if (guest) api.get(`/orders/${orderNumber}?email=${encodeURIComponent(guest)}`).then(({ data }) => setOrder(data)).catch(() => {});
      });
  }, [orderNumber, customer]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <Helmet><title>Siparişiniz Alındı | BIGELDİ</title></Helmet>
      <motion.div initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", damping: 14 }}>
        <CheckCircle2 size={72} className="mx-auto text-emerald-500" />
      </motion.div>
      <h1 className="font-display font-extrabold text-3xl mt-6" data-testid="order-success-title">Siparişiniz Alındı!</h1>
      <p className="text-neutral-500 mt-2 text-sm">Sipariş onayınız e-posta adresinize gönderilecektir.</p>
      <div className="bg-white border border-[#E6E4DD] rounded-2xl p-6 mt-8 text-left">
        <div className="flex justify-between items-center pb-4 border-b border-[#E6E4DD]">
          <div>
            <p className="text-[11px] text-neutral-400 uppercase tracking-widest font-mono-ed">Sipariş Numarası</p>
            <p className="font-mono-ed font-bold text-lg" data-testid="order-success-number">{orderNumber}</p>
          </div>
          {order && <p className="font-mono-ed font-bold text-xl">{fmtTRY(order.total)}</p>}
        </div>
        {order && (
          <div className="pt-4 space-y-2 text-sm">
            {order.items.map((i) => (
              <div key={i.product_id + (i.variant_id || "")} className="flex justify-between">
                <span className="text-neutral-600">{i.name} {i.variant_label ? `(${i.variant_label})` : ""} × {i.quantity}</span>
                <span className="font-semibold">{fmtTRY(i.line_total)}</span>
              </div>
            ))}
            <div className="flex justify-between text-neutral-500 pt-2 border-t border-[#E6E4DD]"><span>Kargo</span><span>{order.shipping_fee === 0 ? "Ücretsiz" : fmtTRY(order.shipping_fee)}</span></div>
            <p className="text-xs text-neutral-400 pt-1">{fmtDate(order.created_at)}</p>
          </div>
        )}
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
        <Link to={`/siparis-takip`} className="px-8 py-3.5 rounded-full border-2 border-[#121214] font-semibold hover:bg-[#121214] hover:text-white transition-colors" data-testid="order-success-track">
          Siparişimi Takip Et
        </Link>
        <Link to="/ara" className="px-8 py-3.5 rounded-full bg-amber-600 text-white font-semibold hover:bg-amber-500 transition-colors" data-testid="order-success-continue">
          Alışverişe Devam Et
        </Link>
      </div>
    </div>
  );
}
